var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group relative inline-block max"},[_c('span',{},[_vm._v(_vm._s(_vm.renderValue(_vm.value)))]),_vm._v(" "),_c('div',{class:_vm.tooltipClass},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }